export default defineNuxtRouteMiddleware((to, from) => {
  const { accessTokenState, refreshTokenState } = useAuthState();

  if (to.fullPath.startsWith('/auth')) {
    if (accessTokenState?.value) {
      if (to?.query?.externalUrl) {
        return navigateTo(to.query?.externalUrl + `?accessToken=${accessTokenState.value}&refreshToken=${refreshTokenState.value}`, { external: true });
      } else {
        return navigateTo({ path: '/app' });
      }
    }
  }
});
